import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useVisitorTracking } from "@/hooks/useVisitorTracking";
import { AuthProvider } from "@/hooks/useAuth";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";
import Index from "./pages/Index";
import About from "./pages/About";
import Accessories from "./pages/Accessories";
import Affiliate from "./pages/Affiliate";
import Robots from "./pages/Robots";
import AIAutomation from "./pages/AIAutomation";
import AISocialCampaign from "./pages/AISocialCampaign";
import Sora2Video from "./pages/Sora2Video";
import CC1Pro from "./pages/CC1Pro";
import CC1 from "./pages/CC1";
import MT1Max from "./pages/MT1Max";
import MT1 from "./pages/MT1";
import SH1 from "./pages/SH1";
import PuduD9 from "./pages/PuduD9";
import FlashBotArm from "./pages/FlashBotArm";
import BellaBotPro from "./pages/BellaBotPro";
import T300Series from "./pages/T300Series";
import KettyBotPro from "./pages/KettyBotPro";
import HolaBot from "./pages/HolaBot";
import PuduT600 from "./pages/PuduT600";
import MT1Vac from "./pages/MT1Vac";
import BellaBot from "./pages/BellaBot";
import PuduBot2 from "./pages/PuduBot2";
import FlashBotMax from "./pages/FlashBotMax";
import SwiftBot from "./pages/SwiftBot";
import Restaurants from "./pages/Restaurants";
import Hotels from "./pages/Hotels";
import Healthcare from "./pages/Healthcare";
import Warehouses from "./pages/Warehouses";
import Education from "./pages/Education";
import CaseStudies from "./pages/CaseStudies";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Careers from "./pages/Careers";
import RobotRecommender from "./pages/RobotRecommender";
import Analytics from "./pages/Analytics";
import Auth from "./pages/Auth";
import Blog from "./pages/Blog";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const AppContent = () => {
  useVisitorTracking();
  return null;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <AppContent />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/accessories" element={<Accessories />} />
            <Route path="/affiliate" element={<Affiliate />} />
            <Route path="/robots" element={<Robots />} />
          <Route path="/ai-automation" element={<AIAutomation />} />
          <Route path="/ai-social-campaign" element={<AISocialCampaign />} />
          <Route path="/sora-2-video" element={<Sora2Video />} />
            <Route path="/robots/cc1-pro" element={<CC1Pro />} />
            <Route path="/robots/cc1" element={<CC1 />} />
            <Route path="/robots/mt1-max" element={<MT1Max />} />
            <Route path="/robots/mt1" element={<MT1 />} />
            <Route path="/robots/mt1-vac" element={<MT1Vac />} />
            <Route path="/robots/sh1" element={<SH1 />} />
            <Route path="/robots/pudu-d9" element={<PuduD9 />} />
            <Route path="/robots/flashbot-arm" element={<FlashBotArm />} />
            <Route path="/robots/bellabot-pro" element={<BellaBotPro />} />
            <Route path="/robots/t300-series" element={<T300Series />} />
            <Route path="/robots/kettybot-pro" element={<KettyBotPro />} />
            <Route path="/robots/holabot" element={<HolaBot />} />
            <Route path="/robots/pudu-t600" element={<PuduT600 />} />
            <Route path="/robots/mt1-vac" element={<MT1Vac />} />
            <Route path="/robots/bellabot" element={<BellaBot />} />
            <Route path="/robots/pudubot-2" element={<PuduBot2 />} />
            <Route path="/robots/flashbot-max" element={<FlashBotMax />} />
            <Route path="/robots/swiftbot" element={<SwiftBot />} />
            <Route path="/restaurants" element={<Restaurants />} />
            <Route path="/hotels" element={<Hotels />} />
            <Route path="/healthcare" element={<Healthcare />} />
            <Route path="/warehouses" element={<Warehouses />} />
            <Route path="/education" element={<Education />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/robot-recommender" element={<RobotRecommender />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/auth" element={<Auth />} />
            <Route 
              path="/analytics" 
              element={
                <ProtectedRoute requireAdmin>
                  <Analytics />
                </ProtectedRoute>
              } 
            />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
